(function () {
  window.__rmVariantFixLoaded = true;

  if (!/\/products\//.test(location.pathname)) return;

  let __rmCachedProductUrl = null;
  let __rmCachedProduct = null;
  let __rmVariantIndex = null;
  let __rmAbort = null;
  let __rmSyncSeq = 0;
  let __rmUserInteracted = false;

  const moneyFormat = document.body.dataset.moneyFormat || '£{{amount}}';

  function getProductOptionsRoot() {
    return document.querySelector('product-options[data-product-url]');
  }

  function getProductUrl(root) {
    return (root && root.dataset && root.dataset.productUrl) ? root.dataset.productUrl : location.pathname;
  }

  function getSelectedOptions(root) {
    const chosenLis = Array.from(root.querySelectorAll('li.product-option-picker__list-item.chosen[data-option-value]'));
    if (chosenLis.length) return chosenLis.map(li => li.getAttribute('data-option-value'));

    const checked = Array.from(root.querySelectorAll('input[type="radio"]:checked'));
    if (checked.length) {
      const byName = new Map();
      checked.forEach(i => byName.set(i.name, i.value));
      return Array.from(byName.values());
    }

    return [];
  }

  async function getProductJson(productUrl) {
    const normalized = productUrl.replace(/\/$/, '');

    if (__rmCachedProduct && __rmCachedProductUrl === normalized) return __rmCachedProduct;

    if (__rmAbort) {
      try { __rmAbort.abort(); } catch(e) {}
    }
    __rmAbort = new AbortController();

    const res = await fetch(normalized + '.js', { credentials: 'same-origin', signal: __rmAbort.signal });
    const data = await res.json();

    __rmCachedProductUrl = normalized;
    __rmCachedProduct = data;

    __rmVariantIndex = new Map();
    if (data && data.variants) {
      data.variants.forEach(v => {
        const opts = [v.option1, v.option2, v.option3].filter(Boolean).map(String);
        __rmVariantIndex.set(opts.join('|||'), v);
      });
    }

    return data;
  }

  function findVariant(product, selectedValues) {
    if (!product || !product.variants || !selectedValues || !selectedValues.length) return null;
    if (__rmVariantIndex) {
      return __rmVariantIndex.get(selectedValues.map(String).join('|||')) || null;
    }
    return product.variants.find(v => {
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      if (opts.length !== selectedValues.length) return false;
      return opts.every((val, idx) => String(val) === String(selectedValues[idx]));
    }) || null;
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    // fallback: simple £X.XX
    return moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2));
  }

  function updatePriceBlock(container, variant) {
    const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    container.classList.toggle('product-price-on-sale', !!(isOnSale && variant.available));

    const priceEl = container.querySelector('[data-price]');
    if (priceEl && variant.price != null) priceEl.textContent = formatMoney(variant.price);

    const comparePriceEl = container.querySelector('[data-price-compare]');
    if (comparePriceEl) {
      if (isOnSale) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    const saleBadge = container.querySelector('.product-sale-badge');
    if (saleBadge) saleBadge.style.display = isOnSale ? '' : 'none';
  }

  function updateButton(btn, variant, addToCartText, soldOutText) {
    btn.disabled = !variant.available;
    const textSpan = btn.querySelector('[data-text]');
    if (textSpan) {
      const innerSpan = textSpan.querySelector('span');
      const label = variant.available ? addToCartText : soldOutText;
      textSpan.setAttribute('data-text', label);
      if (innerSpan) innerSpan.textContent = label;
    }
  }

  function updateDOM(variant) {
    if (!variant) return;

    // Update URL without reload
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({ variantId: variant.id }, '', url.toString());

    // Update hidden variant ID for cart form submission
    const idInput = document.querySelector('product-variants-selector input[name="id"]');
    if (idInput) idInput.value = variant.id;

    // Update all price blocks (main + sticky ATC)
    document.querySelectorAll('.product-price').forEach(block => updatePriceBlock(block, variant));

    // Update main add-to-cart button
    const addBtn = document.querySelector('#AddToCart');
    if (addBtn) {
      updateButton(addBtn, variant,
        addBtn.dataset.textAddToCart || 'Add to cart',
        addBtn.dataset.textSoldOut || 'Sold out'
      );
    }

    // Update sticky ATC bar
    const stickyBar = document.querySelector('sticky-bar');
    if (stickyBar) {
      stickyBar.classList.toggle('product-currently-not-available', !variant.available);

      const stickyBtn = stickyBar.querySelector('.product-sticky-bar-add-to-cart');
      if (stickyBtn) {
        updateButton(stickyBtn, variant,
          stickyBtn.dataset.textAddToCart || addBtn && addBtn.dataset.textAddToCart || 'Add to cart',
          stickyBtn.dataset.textSoldOut || addBtn && addBtn.dataset.textSoldOut || 'Sold out'
        );
      }

      const stickyVariantTitle = stickyBar.querySelector('.product-sticky-bar-chosen-variant');
      if (stickyVariantTitle && variant.title && variant.title !== 'Default Title') {
        stickyVariantTitle.textContent = variant.title;
      }
    }

    // Update quantity max
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (qtyInput) {
      if (variant.inventory_management) {
        qtyInput.max = variant.inventory_quantity;
      } else {
        qtyInput.removeAttribute('max');
      }
    }

    // Update stock count block
    const stockEl = document.querySelector('.product-inventory-qty');
    if (stockEl) {
      const threshold = parseInt(stockEl.dataset.lowStockThreshold, 10) || 0;
      const qty = variant.inventory_quantity;
      const managed = variant.inventory_management;
      const continuePolicy = variant.inventory_policy === 'continue';

      let p = stockEl.querySelector('p');
      if (!p) {
        p = document.createElement('p');
        stockEl.appendChild(p);
      }
      p.className = '';

      if (!variant.available && managed && !continuePolicy) {
        p.className = 'product-summary__inventory-qty--sold';
        p.textContent = stockEl.dataset.textSold || 'Sold out';
      } else if (!managed || continuePolicy) {
        p.className = 'product-summary__inventory-qty--normal';
        p.textContent = stockEl.dataset.textInStockNoTrack || 'In stock';
      } else if (threshold > 0 && qty <= threshold) {
        p.className = 'product-summary__inventory-qty--low';
        p.textContent = (stockEl.dataset.textLowStock || 'Only %s left').replace('%s', qty);
      } else {
        p.className = 'product-summary__inventory-qty--normal';
        p.textContent = (stockEl.dataset.textInStock || '%s in stock').replace('%s', qty);
      }
    }
  }

  async function syncVariant() {
    if (!__rmUserInteracted) return;

    const root = getProductOptionsRoot();
    if (!root) return;

    const productUrl = getProductUrl(root);
    const selected = getSelectedOptions(root);
    if (!selected.length) return;

    const seq = ++__rmSyncSeq;

    try {
      const product = await getProductJson(productUrl);
      if (seq !== __rmSyncSeq) return;

      const variant = findVariant(product, selected);
      if (!variant || !variant.id) return;

      updateDOM(variant);
    } catch (err) {
      if (err && (err.name === 'AbortError' || String(err).includes('AbortError'))) return;
      console.error('[RM] Error syncing variant', err);
    }
  }

  function observeChanges() {
    const root = getProductOptionsRoot();
    if (!root) return;

    root.addEventListener('click', () => { __rmUserInteracted = true; }, true);
    root.addEventListener('change', () => { __rmUserInteracted = true; }, true);

    const mo = new MutationObserver(() => {
      clearTimeout(window.__rmVariantFixT);
      window.__rmVariantFixT = setTimeout(syncVariant, 40);
    });

    mo.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-pressed']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeChanges);
  } else {
    observeChanges();
  }
})();
